import React from "react";

const siteUrl = "https://danbydesign.co.uk";

const Seo = ({ title, description, pathname = "", children }) => {
  const url = `${siteUrl}${pathname}`;
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    name: "Danby Design",
    url: siteUrl,
    areaServed: "United Kingdom",
    priceRange: "GBP 200 + GBP 5/month",
    description:
      "Web design for sole traders and small businesses. Fast, SEO-ready brochure sites with simple pricing.",
    serviceType: "Web design",
    offers: {
      "@type": "Offer",
      price: "200",
      priceCurrency: "GBP",
      description:
        "Standard brochure website (3-4 pages) plus GBP 5/month hosting/email/content tweaks.",
    },
  };

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="Danby Design" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      {children}
    </>
  );
};

export default Seo;
